import BreadCrumb from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import PublicContainer from 'components/__SHARED__/PublicContainer';
import { basePath } from 'library/Routes';
import { Col, Row } from 'plataforma-fundacao-componentes';
import { Fragment } from 'react';
import { Helmet } from 'react-helmet';

export default function PrivacyPolicy() {
  return (
    <Fragment>
      <Helmet>
        <link
          href='https://web-static.sicredi.io/lgpd-politica-privacidade-lib@1/static/css/main.css'
          rel='stylesheet'
        />

        <script src='https://web-static.sicredi.io/lgpd-politica-privacidade-lib@1/static/js/main.js' />
      </Helmet>
      <PublicContainer>
        <Row style={{ maxWidth: '1054px' }}>
          <Col style={{ marginTop: '12px' }}>
            <BreadCrumb
              itens={[
                { nome: 'Ínicio', url: basePath },
                {
                  nome: 'Política de privacidade',
                },
              ]}
            />
          </Col>
        </Row>
        <Col style={{ maxWidth: '1054px' }}>
          <div id='politica-privacidade-root' />
        </Col>
      </PublicContainer>
    </Fragment>
  );
}
